import { BackIcon } from 'assets/icons';
import { CustomButton, CustomTextArea } from 'components';
import { ButtonType } from 'components/custom-button/CustomButton';
import React, { FC, useState } from 'react';
import { useEditJobDescriptionMutation } from '../api';
import { API_RESPONSES } from 'types/baseTypes';

interface EditDescriptionPanelProps {
  description: string;
  onBackClick: () => void;
  onSave: (description: string) => void;
  jobId: string;
  teamId: number;
}

const EditDescriptionPanel: FC<EditDescriptionPanelProps> = ({ description, onBackClick, onSave, jobId, teamId }) => {
  const [jobDescription, setJobDescription] = useState(description);

  const [editJobDescriptionMutation, editJobDescriptionState] = useEditJobDescriptionMutation();
  const { isLoading: isEditJobDescriptionLoading } = editJobDescriptionState;

  const onSaveClick = () => {
    editJobDescriptionMutation({
      description: jobDescription.trim(),
      jobId,
      teamId
    }).then(response => {
      if ('data' in response && response.data.data.message === API_RESPONSES.SUCCESS) {
        onSave(jobDescription.trim());
      }
    });
  };
  return (
    <div className="h-full w-96">
      <div className="mb-1 flex items-center border-b border-secondaryBtn py-4">
        <BackIcon className="mx-4 cursor-pointer" id="job-details-panel-back-arrow" onClick={onBackClick} />
        <div className="text-17px font-semibold text-headingGray">Job description</div>
      </div>
      <div className="py-6 px-4">
        <CustomTextArea
          id="edit-Description-note"
          name="edit-Description-note"
          placeholder="Enter job description"
          className="h-[140px] max-h-[140px] rounded-md border border-borderGray bg-transparent font-semibold 
                    text-primaryText focus:outline-none"
          value={jobDescription}
          onChange={setJobDescription}
        />
      </div>
      <div className="flex w-full flex-col gap-y-4 p-4">
        <CustomButton
          id="edit-Description-save-button"
          className="w-full"
          onClick={onSaveClick}
          isLoading={isEditJobDescriptionLoading}
          type={ButtonType.PRIMARY}
          disabled={description.trim() === jobDescription.trim()}>
          Save
        </CustomButton>
        <CustomButton
          id="edit-Description-cancel-button"
          className="w-full"
          onClick={onBackClick}
          type={ButtonType.SECONDARY}>
          Cancel
        </CustomButton>
      </div>
    </div>
  );
};

export default EditDescriptionPanel;
